import { useState, useCallback } from 'react';

export const usePaginatedFetch = ({ url, headers, mapper = null, perPage = 50 }) => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const fetchPage = useCallback(async (pageNum = 1, replace = false) => {
        setLoading(true);
        try {
            const separator = url.includes('?') ? '&' : '?';
            const res = await fetch(`${url}${separator}page=${pageNum}&per_page=${perPage}`, { headers });

            if (!res.ok) {
                setLoading(false);
                return;
            }

            const json = await res.json();
            const totalCount = parseInt(res.headers.get('X-WP-Total') || '0', 10);

            let items = [];
            if (Array.isArray(json)) {
                items = mapper ? json.map(mapper).filter(Boolean) : json;
            } else if (json && json.data && Array.isArray(json.data)) {
                // Handle paginated responses wrapped in a data object if that ever happens
                items = mapper ? json.data.map(mapper).filter(Boolean) : json.data;
            }

            setTotal(totalCount);
            setHasMore(pageNum * perPage < totalCount);
            setData(prev => replace ? items : [...prev, ...items]);
            setPage(pageNum);
        } catch (err) {
            console.error('Paginated fetch error:', err);
        } finally {
            setLoading(false);
        }
    }, [url, headers, mapper, perPage]);

    const loadMore = () => fetchPage(page + 1, false);
    const refresh = () => fetchPage(1, true);

    return { data, total, loading, hasMore, loadMore, refresh, fetchPage };
};
